var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.initializing
      ? _c("div", { staticClass: "skeleton skeleton2" })
      : _c(
          "div",
          { staticClass: "row product" },
          [
            _c(
              "div",
              {
                staticClass: "small-12 large-9 column v-spacing-child-6@large",
              },
              [
                _vm._l(
                  _vm.configuratorService.observableData.data.configgroups,
                  function (group, index) {
                    return [
                      index === 0
                        ? _c(
                            "ProductIsland",
                            { key: group.title },
                            [
                              _c(
                                "OptionGroupMain",
                                { attrs: { data: group } },
                                [
                                  _c("ConfigOptions", {
                                    attrs: {
                                      group: group,
                                      baseWidth: 6,
                                      doubleWidthAllowed: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "top",
                                          fn: function () {
                                            return [
                                              _vm.configuratorService.isConfigTypePresent(
                                                _vm.printqService.TYPE
                                              )
                                                ? _c("PrintQFields")
                                                : _vm._e(),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _vm.configuratorService.observableData.data
                                    .text
                                    ? _c("div", {
                                        staticClass: "mt-1",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.configuratorService
                                              .observableData.data.text
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "OptionGroupGeneral",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.configuratorService.showGroup(group),
                                  expression:
                                    "configuratorService.showGroup(group)",
                                },
                              ],
                              key: group.title,
                              attrs: { group: group },
                            },
                            [
                              _c("ConfigOptions", {
                                attrs: {
                                  group: group,
                                  baseWidth: 4,
                                  doubleWidthAllowed: false,
                                },
                              }),
                            ],
                            1
                          ),
                    ]
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "small-12 large-3 column sticky-container" },
              [
                _c(
                  "div",
                  { staticClass: "sticky", attrs: { "data-margin-top": "0" } },
                  [
                    _c("PriceBox", { attrs: { shopItemId: _vm.shopItemId } }),
                    _vm._v(" "),
                    _c(
                      "ButtonGroup",
                      [
                        this.configuratorService.isConfigTypePresent(
                          _vm.printqService.TYPE
                        )
                          ? _c("PrintQButtonGroup")
                          : _vm._e(),
                        _vm._v(" "),
                        this.configuratorService.isConfigTypePresent("CreateX")
                          ? _c("CreateXButtonGroup")
                          : _vm._e(),
                        _vm._v(" "),
                        _c("PrintOfferButton"),
                        _vm._v(" "),
                        _c("SaveProductConfigurationButton", {
                          attrs: { configInvalid: _vm.customizationInvalid },
                        }),
                        _vm._v(" "),
                        _c("SendProductOfferButton", {
                          attrs: { configInvalid: _vm.customizationInvalid },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("DatenblattButton"),
                            _vm._v(" "),
                            _c("OrderSampleButton"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("DownloadSection", {
              attrs: {
                vorlagen:
                  _vm.configuratorService.observableData.data
                    .gestaltungsvorlagen,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }